import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import './../../pages/properties/property.css'; // TODO Should we share this or move it!?
import './company-tile.css';

export const CompanyTiles = ({ companies, showDelete, onToggleDelete }) => {
    // State to track which companies are marked for deletion
    const [selectedCompanies, setSelectedCompanies] = useState({});

    // Reset selected companies when showDelete changes
    useEffect(() => {
        if (!showDelete) {
            setSelectedCompanies({});
        }
    }, [showDelete]);

    const companyLogoPath = company => {
        return company.logoPathIncludingSasToken;
    }

    const imageNotAvailableClass = company => {
        const result = "property product" + (companyLogoPath(company) ? "" : " not-available");
        return result;
    }

    const imageStyle = company => {
        const unknown = { marginTop: "20px", alignSelf: "center", width: "50%", backgroundImage: 'url(/assets/img/pos/unknown-house.png)' };
        const known = { backgroundImage: `url(${companyLogoPath(company)})` };
        return companyLogoPath(company) ? known : unknown;
    }

    const handleDeleteChange = (company, event) => {
        const isChecked = event.target.checked;
        
        // Update the state with the new selection
        setSelectedCompanies(prev => {
            const updated = { ...prev };
            if (isChecked) {
                updated[company.id] = true;
            } else {
                delete updated[company.id];
            }
            return updated;
        });
        
        // Update the company object for external use
        company.toDelete = isChecked;
        
        // Call the parent component's handler if provided
        if (onToggleDelete) {
            onToggleDelete(company);
        }
    }

    return (companies && companies.map((company, i) => (
        <div key={`company-${company.id}-counter-${i}`} className="product-container" >
            {showDelete && (
                <div className="delete-checkbox">
                    <input
                        type="checkbox"
                        id={`delete-company-${company.id}`}
                        className="form-check-input"
                        checked={!!selectedCompanies[company.id]}
                        onChange={(e) => handleDeleteChange(company, e)}
                    />
                    <label 
                        htmlFor={`delete-company-${company.id}`} 
                        className="form-check-label visually-hidden"
                    >
                        Mark {company.name} for deletion
                    </label>
                </div>
            )}
            <Link to={`/company/detail/${company.id}`} className={imageNotAvailableClass(company)}>
                <div className="img mt-10px" style={imageStyle(company)}></div>
                <div className="text">
                    <div className="property-description mt-auto">{company.name}</div>
                </div>
                {!companyLogoPath(company) && (
                    <div className="not-available-text">
                        <div>Image Not Available</div>
                    </div>
                )}
            </Link>
        </div>
    )));
};